<template>
  <nav class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light dark-blue-sidebar" id="sidenav-main">
    <div class="container-fluid">

      <!-- Toggler -->
      <navbar-toggle-button @click.native="showSidebar"></navbar-toggle-button>

      <img :src="logo" class="navbar-brand-img" alt="...">

      <slot name="mobile-right">
        <ul class="nav align-items-center d-md-none">
          <!-- <base-dropdown class="nav-item" menu-on-right tag="li" title-tag="a">
            <a slot="title-container" class="nav-link nav-link-icon" href="#" role="button" aria-haspopup="true" aria-expanded="false">
              <i class="ni ni-bell-55"></i>
            </a>

            <a class="dropdown-item" href="#">Action</a>
            <a class="dropdown-item" href="#">Another action</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#">Something else here</a>
          </base-dropdown> -->
          <base-dropdown class="nav-item" menu-on-right tag="li" title-tag="a">
            <a slot="title-container" class="nav-link" href="#" role="button">
              <div class="media align-items-center">
                <span class="avatar avatar-sm rounded-circle">
                  <img alt="Image placeholder" src="img/theme/team-4b.jpg">
                </span>
            <b-media-body class="ml-2 d-none d-lg-block">
              <span class="mb-0 text-sm  font-weight-bold">{{nama}}</span>
            </b-media-body>
              </div>
            </a>

            <div class="dropdown-header noti-title">
              <h6 class="text-overflow m-0">{{peranan}}</h6>
            </div>
            <!-- <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-single-02"></i>
              <span>My profile</span>
            </router-link>
            <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-settings-gear-65"></i>
              <span>Settings</span>
            </router-link>
            <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-calendar-grid-58"></i>
              <span>Activity</span>
            </router-link>
            <router-link to="/profile" class="dropdown-item">
              <i class="ni ni-support-16"></i>
              <span>Support</span>
            </router-link> -->
            <div class="dropdown-divider"></div>
            <a href="#!" class="dropdown-item" @click="logout">
              <i class="ni ni-user-run"></i>
              <span>Logout</span>
            </a>
          </base-dropdown>
        </ul>
      </slot>
      <slot></slot>
      <div v-show="$sidebar.showSidebar" class="navbar-collapse collapse show" id="sidenav-collapse-main">

        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <router-link to="/">
                <img :src="logo">
              </router-link>
            </div>
            <div class="col-6 collapse-close">
              <navbar-toggle-button @click.native="closeSidebar"></navbar-toggle-button>
            </div>
          </div>
        </div>

        <ul class="navbar-nav">
          <slot name="links"></slot>
        </ul>
        <!-- Divider -->
        <hr class="my-3">
      </div>
    </div>
  </nav>
</template>

<script>
import NavbarToggleButton from '@/components/NavbarToggleButton'
import PenggunaService from '@/services/PenggunaService.js';

export default {
  name: 'sidebar',
  components: {
    NavbarToggleButton
  },
  props: {
    logo: {
      type: String,
      default: 'img/brand/jata-negara3.png',
      description: 'Sidebar app logo'
    },
    autoClose: {
      type: Boolean,
      default: true,
      description: 'Whether sidebar should autoclose on mobile when clicking an item'
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    closeSidebar() {
      this.$sidebar.displaySidebar(false)
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true)
    },
            logout(){
      //alert('logout')
      PenggunaService.ev_logout().then(()=>{
        console.log('Logout for active session successfull')
      }).then(()=>{
        this.$store.commit('logout')
        this.$router.push('/login')
      })
      
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    nama(){
      return this.$store.state.Pengguna.name
    },
    peranan(){
      const roleId=this.$store.state.Pengguna.roleID
      return PenggunaService.getPeranan(roleId)
    }
  },
};
</script>

<style scoped>
/* Styles for the dark blue sidebar */
.dark-blue-sidebar {
  background-color: #024052; /* Dark blue color */
  color: rgb(240, 236, 236); /* White text for contrast */
}

/* Add shadow to the text */
.dark-blue-sidebar .nav-link,
.dark-blue-sidebar .navbar-brand {
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.7); /* Shadow effect */
}

/* Change link colors */
.dark-blue-sidebar .nav-link {
  color: #ffffff; /* White link color */
}

/* Change link hover effects */
.dark-blue-sidebar .nav-link:hover {
  background-color: rgba(255, 255, 255, 0.1); /* Lighten on hover */
}

/* Style for the navbar brand image */
.navbar-brand-img {
  height: auto; /* Adjust the height */
  max-height: 85px; /* Set maximum height for the logo */
}

@media (min-width: 768px) {
    .navbar-vertical.navbar-expand-md .navbar-brand-img {
        max-height: 5.5rem;
    }
}  

.navbar-vertical .navbar-brand-img{
  max-width: 129px;
}

.navbar-brand-img{
margin-left:35px;
}
</style>
